type DepictLanguages =
	| "da_DK"
	| "de_AT"
	| "de_DE"
	| "en_GB"
	| "en_IE"
	| "et_EE"
	| "fi_FI"
	| "no_NO"
	| "sv_SE";

//if new depict languages are added, add them here, or find a better solution than this using the available languages
export function localeToBCP47(language: string): DepictLanguages {
	const bcp47Options: DepictLanguages[] = [
		"da_DK",
		"de_AT",
		"de_DE",
		"en_GB",
		"en_IE",
		"et_EE",
		"fi_FI",
		"no_NO",
		"sv_SE",
	];

	const match = bcp47Options.find((code) => code.startsWith(`${language}_`));
	return match || "en_GB";
}
